import { userConstants } from '../_constants';
import { utils } from '../_helpers/utils'

let user = utils.CheckUser();

const initialState = user ? {loggedIn : true , user } : {}; 

export function authentication(state = initialState , action){
    switch (action.type){
      case userConstants.LOGIN_REQUEST:
        return {
          user: action.user
        };
      case userConstants.LOGIN_SUCCESS:
        return {
          user: action.user
        };
      case userConstants.LOGIN_FAILURE:
        return {
          error : action.error
        };

      case userConstants.REFRESHTOKEN_REQUEST:
        return {
          user: action.user
        };
      case userConstants.REFRESHTOKEN_SUCCESS:
        return {
          user: action.user
        };
      case userConstants.REFRESHTOKEN_FAILURE:
        return {
          error : action.error
        };

      case userConstants.LOGOUT:
      return {
      };
      
        
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js